import React, { useEffect, useState } from 'react';
import {
  ContainerSchedule,
  CourseData,
  CourseTitle,
  SubCourseData,
  TextSchedule
} from './styled';
import {
  formatSchedulesDays,
  renderTeachers,
  getTypeConfig
} from '../Desktop/SubTableSchedules';
import { TableBody } from '../Desktop/styled';
import { TitleBold, SubTitle } from '../styled';
import { Block, Tag } from '@/presentation/components';
import Spinner from '@/presentation/components/Spinner';
import ModalSchedule from '../../../../components/ModalSchedule/ModalSchedule';
import { ShowSchedulesProps as IProps } from '../../interfaces/propsCourseSchedule';
import EmptyDataStateMessage from '@/presentation/reusables/EmptyDataStateMessage';

const ShowSchedulesMobile = ({
  show,
  courseSelected,
  isLoadingSchedules,
  schedulesSelected,
  onClose
}: IProps) => {
  const [typeSelected, setTypeSelected] = useState('');
  const [isSimulator, setIsSimulator] = useState(false);

  const handleSelectType = (type: string) => {
    setTypeSelected(type === 'O' ? 'Obligatorio' : 'Electivo');
  };
  const handlerIsSimulator = () => {
    const simulator = localStorage.getItem('persist:simulator');
    setIsSimulator(
      simulator ? JSON.parse(simulator).isSimulator === 'true' : false
    );
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      handleSelectType(courseSelected?.type);
      handlerIsSimulator();
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  const contentByScheduleSelected = () =>
    schedulesSelected?.length > 0 ? (
      schedulesSelected.map((schedule: any, index: number) => (
        <TableBody
          key={`schedule-${schedule.section}-${index}`}
          expanded={false}
          style={{
            paddingRight: '4px',
            borderRadius: '4px',
            border: '1px solid #A8CBE2'
          }}
          isMobile
        >
          <TextSchedule isSection>Sección: {schedule.section}</TextSchedule>
          <TextSchedule>
            {schedule.typeCourse === 'VT' ? (
              <div>Disponible las 24 horas durante el ciclo</div>
            ) : (
              formatSchedulesDays(schedulesSelected)
                ?.filter(
                  (h) =>
                    h.section === schedule.section &&
                    h.courseId === schedule.courseId
                )
                .map((h, i) => (
                  <div
                    key={`${h.day}-${h.start}-${h.end}`}
                    style={{ marginTop: 0 }}
                  >
                    {i === 0 && 'Horario: '}
                    {h.day} {h.start} - {h.end}
                  </div>
                ))
            )}
          </TextSchedule>
          <TextSchedule>{renderTeachers(schedule.teachers, true)}</TextSchedule>
          <TextSchedule style={{ marginBottom: 12 }}>
            <Block flex className="headerLabel">
              <Tag
                backgroundColor={getTypeConfig(schedule.typeCourse).bg}
                width={getTypeConfig(schedule.typeCourse).width}
                color={getTypeConfig(schedule.typeCourse).color}
                padding="4px 12px 4px 12px"
                radius={20}
                lineHeight={16}
                size={12}
                height={24}
                bold
                gap={10}
              >
                {getTypeConfig(schedule.typeCourse).text}
              </Tag>
            </Block>
          </TextSchedule>
        </TableBody>
      ))
    ) : (
      <EmptyDataStateMessage
        message="Por el momento no hay horarios disponibles"
        layout="row"
      />
    );

  return (
    <ModalSchedule
      showModal={show}
      handleClose={() => onClose(courseSelected.id)}
      data-testid="cmp-modal-schedule-mobile"
    >
      <ContainerSchedule
        id="modal-scrollable-content"
        isSimulator={isSimulator}
      >
        <div>
          <TitleBold>Cursos y horarios de matrícula</TitleBold>
          <SubTitle>
            Ten en cuenta que esta información es referencial y puede variar al
            momento de matricularte según las vacantes.
          </SubTitle>
        </div>
        <TableBody
          expanded={false}
          style={{
            gap: '8px',
            padding: '12px',
            borderRadius: '4px',
            border: '1px solid #A8CBE2'
          }}
          isMobile
        >
          <CourseTitle>
            {courseSelected?.code} - {courseSelected?.name}
          </CourseTitle>
          <CourseData>
            <SubCourseData>
              Horas semanales: {courseSelected?.hours}
            </SubCourseData>
            <SubCourseData>Créditos: {courseSelected?.credits}</SubCourseData>
          </CourseData>
          <CourseData>
            <SubCourseData>Ciclo: {courseSelected?.cicle}</SubCourseData>
            <SubCourseData>Tipo: {typeSelected}</SubCourseData>
          </CourseData>
        </TableBody>
        {isLoadingSchedules ? (
          <Spinner height={80} colorText="#5B36F2" />
        ) : (
          contentByScheduleSelected()
        )}
      </ContainerSchedule>
    </ModalSchedule>
  );
};

export default ShowSchedulesMobile;
